import {
  REQUEST_INQUIRY_LIST,
  REQUEST_INQUIRY
} from './mutation-types'

export default {
  [REQUEST_INQUIRY_LIST](state, receivedData) {
    state.inquiryList = receivedData.content
    state.inquiryListCount = receivedData.totalElements
  },
  [REQUEST_INQUIRY](state, receivedData) {
    state.inquiry = receivedData
  }
}